export default __webpack_public_path__ + "static/media/banner-mobile.7ba98ff5.png";